import { ProcessedInvoice } from '../types';

export function sortInvoicesByDueDate(invoices: ProcessedInvoice[]): ProcessedInvoice[] {
  return [...invoices].sort((a, b) => {
    // Handle cases where due date is missing
    if (!a.data.dueDate && !b.data.dueDate) return 0;
    if (!a.data.dueDate) return 1;  // Move items without due date to the end
    if (!b.data.dueDate) return -1;

    // Compare dates
    return new Date(a.data.dueDate).getTime() - new Date(b.data.dueDate).getTime();
  });
}